import { Select, Stack, Text } from "@mantine/core";
import { TwilioContentType, WhatsappTemplateSettings } from "../types";
import { findWhatsappTemplateById, getWhatsappTemplateLabel } from "../helpers/whatsappTemplates";

const getTemplateBody = (template?: WhatsappTemplateSettings): string => {
  const content = template?.templateContent as any;
  const textValue = (content?.types?.["twilio/text"] || content?.types?.["twilio/media"])
    ? (content?.types?.["twilio/text"]?.body || content?.types?.["twilio/media"]?.body)
    : content?.types?.["twilio/call-to-action"]?.body;
  return textValue || template?.title || "";
};

const WhatsAppTemplateSelect = ({
  templates,
  value,
  onChange,
  loading,
  label,
  showPreview = true,
}: {
  templates: WhatsappTemplateSettings[];
  value?: string;
  onChange: (value?: TwilioContentType) => void;
  loading?: boolean;
  label?: string;
  showPreview?: boolean;
}) => {
  const selectedTemplate = findWhatsappTemplateById(templates, value);
  const previewText = getTemplateBody(selectedTemplate);

  return (
    <Stack gap="xs">
      <Select
        label={label || "Select whatsapp template"}
        value={value || null}
        onChange={(val, option) => {
          let foundTemplate = undefined;
          if (val) {
            //find the template with that id 
            foundTemplate = (templates.find((tempalteObj) => tempalteObj.id === val))?.templateContent


          }
          onChange(foundTemplate)
        }}
        data={templates.map((template) => ({
          value: template.id,
          label: getWhatsappTemplateLabel(template),
        }))}
        searchable
        disabled={loading}
        nothingFoundMessage="No templates"
      />
      {showPreview && previewText && (
        <Text size="sm" c="dimmed">
          {previewText}
        </Text>
      )}
    </Stack>
  );
};

export default WhatsAppTemplateSelect;
